import React from "react";
import styled from "styled-components";
import { useField } from "formik";

const TextArea = ({ label, maxLength = 100, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <Wrapper>
      {label && <Label htmlFor={field.name}>{label}</Label>}
      <StyledTextArea {...field} {...props} maxLength={maxLength} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

const Label = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: ${(props) => props.theme.colors.inputLabel};
  margin-bottom: 8px;
  line-height: 18px;
`;

const StyledTextArea = styled.textarea`
  resize: none;
  width: 100%;
  height: 140px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  border-radius: 6px;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.theme.primaryTextColor};
  padding: 12px 16px;
  :focus {
    outline: none;
    border-color: ${(props) => props.theme.colors.inputActive};
  }
  ::placeholder {
    color: #9a9ea8;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
`;

export default TextArea;
